import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { UserService } from "@services/user.service";
import { UserService as UserApiService } from "@services/api/user.service";
import { catchError, map, switchMap, take } from "rxjs/operators";
import { Observable, of } from "rxjs";

@Injectable({ providedIn: "root" })
export class AuthGuard  {
  constructor(private userService: UserService, private userApiService: UserApiService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userService.getUser().pipe(
      take(1),
      switchMap((user) => {
        if (user) {
          return of(true);
        }

        return this.userApiService.me().pipe(
          map(() => true),
          catchError(() => {
            this.router.navigate(["/login"]);
            return of(false);
          })
        );
      })
    );
  }
}
